import React from 'react';

import { Outlet } from 'react-router-dom';

const KitchenProcurementContent = () => {
  return <Outlet />;
};

export default KitchenProcurementContent;
